import ReadMore from "@stimulus-components/read-more";

export default class extends ReadMore {
  static targets = ["content", "button"];

  connect() {
    super.connect();

    this.handleButtonDisplay();
    window.addEventListener("resize", this.handleButtonDisplay.bind(this));
  }

  disconnect() {
    super.disconnect();

    window.removeEventListener("resize", this.handleButtonDisplay.bind(this));
  }

  handleButtonDisplay() {
    const content = this.contentTarget;

    if (content.scrollHeight > content.clientHeight) {
      this.buttonTarget.classList.remove("hidden");
    } else {
      this.buttonTarget.classList.add("hidden");
    }
  }
}
